<template>
  <div class="users">
    <toolbar
      backRoute="/dashboard"
      title="Users"
      :addButton="true"
      addButtonLabel="Add user"
      addButtonRoute="/dashboard/users/new" />

    <d-row class="mt-5">
      <d-col cols="12" class="d-flex">
        <d-input
          v-model="filters.search"
          placeholder="Search users"
          @keyup.native.enter="saveFilters" />

        <div :class="{ 'form-control': true, 'is-select': true, 'ml-2': true }">
          <v-select
            :options="[{ text: 'Administrators', value: 'ADMIN' }, { text: 'Users', value: 'USER' }]"
            v-model="filters.type"
            :reduce="option => option.value"
            label="text"
            placeholder="All users">
          </v-select>
        </div>

        <d-button
          theme="primary"
          outline
          class="ml-2"
          @click.prevent="saveFilters">
          Search
        </d-button>
        <d-button
          v-if="filters.search !== '' || filters.type !== ''"
          theme="danger"
          outline
          class="ml-2"
          @click.prevent="resetFilters">
          Reset
        </d-button>
      </d-col>
    </d-row>

    <table class="table table-striped table-bordered table-hover mt-5">
      <thead>
        <tr>
          <sortable-table-heading field="name" view="users" :column="orderColumn" :direction="orderDirection">Name</sortable-table-heading>
          <sortable-table-heading field="email" view="users" :column="orderColumn" :direction="orderDirection">Email</sortable-table-heading>
          <sortable-table-heading field="type" view="users" :column="orderColumn" :direction="orderDirection">Type</sortable-table-heading>
          <th>Actions</th>
        </tr>
      </thead>

      <tbody v-if="!loadError">
        <tr v-if="!allDataLoaded">
          <td
            colspan="6"
            class="text-center">
            Loading users&hellip;
          </td>
        </tr>
        <tr v-if="allDataLoaded && (!users || (users && users.length === 0))">
            <td
              colspan="6"
              class="text-center">
              There are no users to display&hellip;
            </td>
          </tr>
        <tr
          v-for="(user, index) of users"
          :key="'user-' + index">
          <td class="align-middle">{{ user.name }}</td>
          <td class="align-middle" style="width: 240px;"><a :href="'mailto:' + user.email"><small>{{ user.email }}</small></a></td>
          <td class="align-middle text-center" style="width: 160px;">
            <span class="text-danger" v-if="user.type === 'ADMIN'">Administrator</span>
            <span class="text-light" v-if="user.type === 'USER'">User</span>
          </td>
          <td class="align-middle" style="width: 140px;">
            <d-button
              theme="primary"
              @click.native="$router.push('/dashboard/users/' + user.id)"
              class="mr-2"
              title="Edit user">
              <i class="material-icons">edit</i>
            </d-button>
            <d-button
              theme="danger"
              :disabled="removeInProgress"
              @click.prevent="removeUser(user.id)"
              title="Remove user">
              <i class="material-icons">delete</i>
            </d-button>
          </td>
        </tr>
      </tbody>
    </table>

    <d-alert
      v-if="loadError"
      show
      theme="warning">
      An error occurred during data loading. <a href="javascript:window.location.reload();" class="alert-link">Reload the page</a> to try again.
    </d-alert>

    <pagination :meta-data="paginationMetaData" />
  </div>
</template>

<script>
import HasFilters from './../mixins/HasFilters.vue';
import HasPagination from './../mixins/HasPagination.vue';
import ListUtils from './../utils/ListUtils.js';
import Pagination from './../components/common/Pagination.vue';
import SortableTableHeading from './../components/common/SortableTableHeading.vue';

export default {
  name: 'users',
  additionalFilters: {
    type: null
  },
  mixins: [
    HasFilters,
    HasPagination
  ],
  components: {
    'pagination': Pagination,
    'sortable-table-heading': SortableTableHeading
  },
  filters: {
    formatDateToUK (input) {
      if (!input) {
        return '';
      }

      return input.split('-').reverse().join(' / ');
    }
  },
  computed: {
    allDataLoaded () {
      return this.loaded;
    }
  },
  data () {
    return {
      loaded: false,
      users: null,
      loadError: false,
      removeInProgress: false
    };
  },
  mounted () {
    this.loadFilteredData();
  },
  methods: {
    removeUser (userID) {
      this.removeInProgress = true;

      ListUtils.removeItem({
        $http: this.$http,
        endpointBase: '/users/delete/',
        id: userID,
        successTitle: 'User removed',
        successText: 'The selected user has been removed',
        confirmTitle: 'Do you really want to remove this user?',
        confirmText: 'This operation cannot be reverted',
        errorTitle: 'An error occurred',
        errorText: 'Please try again.',
        successAction: () => {
          this.removeInProgress = false;
          this.loadFilteredData();
        },
        cancelAction: () => {
          this.removeInProgress = false;
        }
      });
    }
  }
};
</script>

<style lang="scss">

</style>
